import { Tooltip } from "@mui/material";
import moment from "moment";
/**
 * This function purpose is to set the default configuration for the columns,
 * asuming some values when not specified
 * @param {Array} columns initial columns to set
 * @param {Boolean} mobileColumns flag used to set the width of the columns to a fixed value
 * If "width" is used for column size, this value should not be sent as true.
 * @returns Customized columns with the needed configuration to show in the table
 */
export const generateColumnsDefaultConfiguration = (
    columns = [],
    mobileColumns,
) => {
    const defaultConfiguration = columns?.map((col, index) => {
        const isFirstColumn = !Boolean(columns[index - 1]);
        const isLastColumn = !Boolean(columns[index + 1]);
        const classByColumnPosition = isFirstColumn ? 'custom-left-margin' : isLastColumn ? 'custom-right-margin' : '';
        const alignmentByColumnPosition = !isLastColumn ? 'left' : 'right';

        let resp = {
            ...col,
            headerClassName: `${col?.headerClassName || ''} ${classByColumnPosition} ${col?.noPaddingHeader && 'no-padding-header'} data-grid-header`,
            cellClassName: `${col?.cellClassName || ''} ${classByColumnPosition} ${col?.noPadding && 'no-padding'} data-grid-cell`,
            align: col?.align || alignmentByColumnPosition,
            headerAlign: col?.headerAlign || alignmentByColumnPosition,
            flex: (col?.flex) ? col?.flex : (!col?.flex && !mobileColumns) ? 0.2 : null,
            width: mobileColumns && col?.width || null,
        };

        if (col.type === 'date') {
            resp.sortComparator = (v1, v2) => {
                if (!v1) return -1;
                if (!v2) return 1;
                return new Date(v1) - new Date(v2);
            }
            resp.valueFormatter = (value) => {
                return (
                    value
                    && moment(value).isValid()
                    && (!col.limitDate || moment(value).year() > col.limitDate)
                )
                    ? moment(value).format(`DD/MM/YYYY ${col.time ? 'HH:mm' : ''}`)
                    : null;
            }
            resp.renderCell = ({ formattedValue }) => {
                return (
                    <Tooltip title={formattedValue}>
                        <span style={{
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden'
                        }}> {formattedValue} </span>
                    </Tooltip>
                );
            }
            return resp;
        }

        if (!col.hideTooltip && !col.renderCell && col.type !== 'boolean') {
            resp = {
                ...resp,
                renderCell:
                    ({ value }) => (
                        <Tooltip title={value}>
                            <span style={{
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden'
                            }}> {value} </span>
                        </Tooltip>
                    ),
            }
        }

        return resp;
    })

    return defaultConfiguration;
}